// @ts-nocheck
/* eslint-disable */
import { _ } from "~/i18n";
import MyMapsExport from "~/ui/dialogs/mymaps-export";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";

export function exportMultiroute(data) {
	if (!("id" in data) || !("title" in data)) {
		return;
	}

	new MyMapsExport({
		data: {
			name: "folder",
			data: {
				mid: data.id,
				title: data.usertitle || data.title,
			},
			isEmpty: data.items.length === 0,
			hasTracks: data.items.filter(item => item.type === "route").length > 0,
		},
		fileTypeFromHeader: true,
	}).open();
}
